const MIN_MS = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? 500 : 3600;
const MAX_MS = 9000;

export function hideSplash(): void {
  const el = document.getElementById("splash");
  if (!el) return;
  const fonts: Promise<unknown> = (document as any).fonts?.ready ?? Promise.resolve();
  const loaded = document.readyState === "complete"
    ? Promise.resolve()
    : new Promise<void>((r) => window.addEventListener("load", () => r(), { once: true }));
  const painted = new Promise<void>((r) => requestAnimationFrame(() => requestAnimationFrame(() => r())));
  const cap = new Promise<void>((r) => setTimeout(r, MAX_MS));

  Promise.race([Promise.all([fonts, loaded, painted]), cap]).then(() => {
    const wait = Math.max(0, MIN_MS - performance.now());
    setTimeout(() => {
      el.classList.add("hide");
      setTimeout(() => el.remove(), 800);
    }, wait);
  });
}
